import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';

// Components 

import Box from '@mui/material/Box';
import Navigation from './navigation/Navigation';
import Doctors from './doctors/Doctors';
import Security from './security/Security';
import Activity from './activity/Activity';
import Section from '../../general/containers/Section';

const Data: React.FC = () => {

    const dispatch = useAppDispatch(); 

    const section = useAppSelector(state => state.hackerData.section); 

    return (

    <Section>

        {/* <Navigation />  */}

        {/* { section === 'doctors' && <Doctors />} */}

        {/* { section === 'security' && <Security />} */}

        {/* { section === 'activity' && <Activity />} */}

        <Security />


    </Section>

  );

};

export default Data;